
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { languageMixin } from "@/mixins/languageMixin";
import { GetContentList, DelContent } from "@/request/common";
import BatchPrinting from "@/components/batch-printing.vue";
import BiduiDialog from "../components/bidui-dialog.vue";
@Component({
  components: {
    BatchPrinting,
    BiduiDialog,
  },
})
export default class Name extends mixins(listMixin, languageMixin) {
  @Watch("patient", { immediate: true })
  private patientChange(content: any) {
    this.search();
  }
  private data: any = [];
  private cTab: any = {};
  private ifShowBatchPrinting: any = false;
  private ifShowBidui: any = false;
  private biduiSelect: any = {};
  private modelData: any = [];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get href() {
    return window.location.href;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private bidui(item: any) {
    this.biduiSelect = item;
    this.ifShowBidui = true;
  }
  private changeCepingTab(item: any) {
    this.cTab = item;
    this.getList();
  }
  private goReport(item: any) {
    // const url: any = this.href.split("/#/")[0];
    // window.open(
    //   url + "/#/main/report/ceping-report?ids=" + JSON.stringify([item.id])
    // );
    this.$router.push({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify([item.id]),
      },
    });
  }
  private goRead(item: any) {
    this.$store.commit("updateIfCompose", false);
    if (item.related_type == "健康测评数据") {
      this.$router.push({
        // path: "/main/manage/edit-ceping2",
        path: "/main/manage/edit-ceping",
        query: {
          template_id: item.template.id,
          patient_id: item.patient.id,
          content_id: item.id,
        },
      });
    } else {
      this.$router.push({
        path: "/main/manage/edit-ceping",
        query: {
          template_id: item.template.id,
          patient_id: item.patient.id,
          content_id: item.id,
        },
      });
    }
  }
  private deleteOne(item: any) {
    this.$confirm("您是否确定删除？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        DelContent(this, item.id, loading).then((data: any) => {
          this.$message.success("删除成功");
          this.getList();
          this.$emit("updateTimeLine");
        });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  /**
   * @description 获取列表
   */
  getList() {
    if (!this.cTab.value) {
      this.cTab = this.modelData[0] || {};
    }
    if (!this.cTab || !this.cTab.value) {
      // modelData还没准备好，直接return
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    localStorage.setItem("cepingFilter", JSON.stringify(this.filters));
    const params: any = {
      params: {
        related_type: this.cTab.value,
        page: this.filters.current_page,
        patient_id: this.patient.id,
        limit: 10,
      },
    };
    GetContentList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    const model: any = JSON.parse(
      JSON.stringify(this.systemInfo.SETTING.model)
    );
    this.modelData = [];
    model.forEach((element: any) => {
      this.modelData.push(this.systemInfo.PART[element]);
    });
    this.getList();
  }
}
